<template>
  <div class="py-6 mx-6">
    <v-row>
      <v-col cols='12' lg='3'>
        <v-card outlined>
          <v-card-title class='text-uppercase text-subtitle-2 title-card white-space'>
            tổng giá trị và số lượng
          </v-card-title>
          <div>
            <v-row class='text-center ma-0'>
              <v-col cols='12'>
                <div class='text-h6 font-weight-medium'> {{ formatCurrency(data.totalMoney) }} </div>
                <div class="content-note mx-auto" style="width: 60%;">Giá trị tính theo hóa đơn nhập (đã bao gồm thuế
                  GTGT)</div>
              </v-col>
              <v-col cols='12'>
                <div class='text-h6 font-weight-medium'> {{ formatCurrency(data.totalProduct) }} sản phẩm</div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols='12' lg='9'>
        <v-card outlined>
          <v-card-title class='text-uppercase text-subtitle-2 title-card'>
            báo cáo giá trị và số lượng thành phần
          </v-card-title>
          <v-row class='text-center ma-0'>
            <v-col cols='12' lg="6">
              <v-row v-for='(item, index) in dataInventory' :key='index'>
                <v-col cols="12">
                  <v-row class='text-subtitle-2' @mousemove="mouOver(item)" @mouseleave="mouOut(item)">
                    <v-col v-if="onResize()" class="text-left" cols="6"> Ngành hàng</v-col>
                    <v-col cols='6' md="3" class='text-uppercase content-text white-space respon-title'
                      style="font-weight: bold; color: #333333;">{{ item.name }}</v-col>
                    <v-col v-if="onResize()" class="text-left" cols="6"> Tổng tiền tồn</v-col>
                    <v-col cols='6' md="5" class=' text-right content-text white-space'
                      style="font-weight: bold; color: #333333;">{{ formatCurrency(item.money) }}</v-col>
                    <v-col v-if="onResize()" class="text-left" cols="6"> Tổng sản phẩm tồn</v-col>
                    <v-col cols='6' md="3" class=' text-right content-text white-space'
                      style="font-weight: bold; color: #333333;">{{
                        formatCurrency(item.product) }}</v-col>
                    <v-col md="1" v-if="!onResize()" class="pt-3 px-0">
                      <v-btn v-show="item.show" icon @click="detailInven(item._id)"><v-icon>mdi-eye</v-icon></v-btn>
                    </v-col>
                    <v-col md="12" class="text-right px-0 pt-0" v-else>
                      <v-btn text color="primary" @click="detailInven(item._id)" small>Xem chi tiết
                        <v-icon class="material-icon" color="primary">keyboard_arrow_right</v-icon></v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-for='(detail, index) in item.category' :key='index' @mousemove="mouOverDetail(detail)"
                    @mouseleave="mouOutDetail(detail)" class='font-weight-light'>
                    <v-col v-if="onResize()" class="pl-2 text-left" cols="6"> Ngành hàng</v-col>
                    <v-col cols='6' md="3" class=" content-text white-space ">
                      <div class="ml-4 respon-title">
                        {{ detail.name }}
                      </div>
                    </v-col>
                    <v-col v-if="onResize()" class="pl-2 text-left" cols="6"> Tổng tiền tồn</v-col>
                    <v-col cols='6' md="5" class=' text-right content-text white-space'>{{
                      formatCurrency(detail.money)
                    }}</v-col>
                    <v-col v-if="onResize()" class="pl-2 text-left" cols="6"> Tổng sản phẩm tồn</v-col>
                    <v-col cols='6' md="3" class=' text-right content-text white-space'>{{ formatCurrency(detail.product)
                    }}</v-col>
                    <v-col md="1" v-if="!onResize()" class="pt-2 mx-0">
                      <v-btn v-show="detail.show" icon
                        @click="detailInven(item._id, detail._id)"><v-icon>mdi-eye</v-icon></v-btn>
                    </v-col>
                    <v-col md="12" class="text-right px-0 pt-0" v-else>
                      <v-btn text color="primary" @click="detailInven(item._id, detail._id)" small>
                        Xem chi tiết
                        <v-icon class="material-icon" color="primary">keyboard_arrow_right</v-icon></v-btn>
                    </v-col>
                  </v-row>
                  <v-divider v-if="index !== dataInventory.length - 1"></v-divider>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols='12' lg="6">
              <InventoryChart :dataInventory="dataInventory" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import InventoryChart from './InventoryChart.vue'
import { mapGetters } from 'vuex'
import { getFirestore, onSnapshot, collection } from 'firebase/firestore'
export default {
  name: 'App',
  components: { InventoryChart },
  data() {
    return {
      data: {
        totalMoney: 0,
        totalProduct: 0
      },
      windowWidth: window.innerWidth,
      dataInventory: [],
      arr: ['samsung', 'sony', 'toshiba', 'hitachi', 'beko', 'sanaky', 'xiaomi', 'khác']
    }
  },
  mounted() {
    if (this.firebaseApp && this.$auth.policies['statistic-list:list-producer-stat-day']) {
      this.setupFireStore()
    }
    this.onResize()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    ...mapGetters({
      firebaseApp: 'firebase/firebaseApp'
    })
  },
  watch: {
    firebaseApp: {
      handler(val) {
        if (val && this.$auth.policies['statistic-list:list-producer-stat-day']) {
          this.setupFireStore()
        }
      }
    }
  },
  methods: {
    formatCurrency(value) {
      return value.toLocaleString('vi-VN', { currency: 'VND' })
    },
    setupFireStore(app) {
      const db = getFirestore(app)
      onSnapshot(collection(db, 'inventory'), querySnapshot => {
        this.dataInventory = []
        this.data.totalMoney = 0
        this.data.totalProduct = 0
        querySnapshot.forEach(doc => {
          const data = doc.data()
          data.show = false
          this.dataInventory.push(data)
          this.dataInventory.sort((a, b) => {
            return this.arr.indexOf(a.name) - this.arr.indexOf(b.name)
          })
        })
        this.dataInventory.forEach(i => {
          this.data.totalMoney += i.money
          this.data.totalProduct += i.product
        })
      })
    },
    mouOver(item) {
      item.show = true
    },
    mouOut(item) {
      item.show = false
    },
    mouOverDetail(item) {
      item.show = true
    },
    mouOutDetail(item) {
      item.show = false
    },
    async detailInven(a, b) {
      try {
        await this.$router.push({
          path: '/inventory-time-report',
          query: {
            producer: a,
            productIndustry: b
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth
      if (this.windowWidth < 960) {
        return true
      }
      return false
    }
  },
}
</script>
<style scoped lang='scss'>
.title-card {
  background-color: #0d47a1;
  color: white;
  line-height: 25px;
  word-break: keep-all;
}

.respon-title {
  @media (max-width: 960px) {
    text-align: right;
  }

  text-align: left;
}

.white-space {
  white-space: nowrap;
  // display: inline-block;
  margin: 0 auto;
}

.content-note {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #757575;
}

.v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
</style>
